import { FC } from 'react'

import { Card } from '@joor/design-system'

import { Flex } from 'styles/components'

import { Order } from '../../types'
import { CardItemHeader, CardItemInfo } from './styles'

const ShippingInfo: FC<{ order: Order }> = ({ order }) => (
  <Card title="Shipping Info">
    <Flex flexDirection="column" rowGap="20px">
      <div>
        <CardItemHeader>Shipping Window</CardItemHeader>
        <CardItemInfo>{order.deliveryWindow}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Delivery Window</CardItemHeader>
        <CardItemInfo>{order.deliveryWindow}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Shipping Address</CardItemHeader>
        {order.shippingAddress.map((data) => (
          <CardItemInfo key={data}>{data}</CardItemInfo>
        ))}
      </div>
      <div>
        <CardItemHeader> Phone Number</CardItemHeader>
        <CardItemInfo>{order.shippingPhone}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Email Address</CardItemHeader>
        <CardItemInfo>{order.shippingEmail}</CardItemInfo>
      </div>
    </Flex>
  </Card>
)
export default ShippingInfo
